import * as React from "react";
import { Slide, styled } from "@mui/material";
import CloseIconButton from "fe-common/ui/icons/closeIconButton";
import { PatientColorMap } from "../../layout/patientColorMap";
import { commonBoxShadowStyle } from "fe-common/ui/boxShadow";
import clsx from "clsx";
import { useCallback, useEffect, useState } from "react";

//region [[ Styles ]]
const PatientPopupBackground = styled("div")({
  position: "absolute",
  zIndex: 9999,
  background: "rgba(0, 0, 0, 0.7)",
  height: "100%",
  width: "calc(100% + 4px)",
  top: 0,
  right: "-2px",
  overflowX: "hidden",
});

const PatientPopupContainer = styled("div")(({ theme }) => ({
  ...commonBoxShadowStyle,
  position: "absolute",
  left: "5%",
  width: "90%",
  padding: "35px",
  margin: "50px 0",
  [theme.breakpoints.up("lg")]: {
    // make sure we look good on desktops 😎
    width: "500px",
    left: "calc(100% - 550px)",
  },
  background: PatientColorMap.White,
  borderRadius: "10px",
  display: "flex",
  boxSizing: "border-box",
  flexFlow: "column",
  justifyContent: "space-between",
  minHeight: "230px",
  alignItems: "center",
}));

const CloseButton = styled(CloseIconButton)({
  "&.close-button": {
    right: 0,
    left: "auto",
    top: "3px",
    boxShadow: "none",
    color: PatientColorMap.Default,
    "& svg": {
      width: "21px",
      height: "21px",
    },
  },
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface PatientPopupContainerProps {
  open: boolean;
  onClose?: () => void;
  className?: string;
  children?: React.ReactNode;
  slideDirection?: "up" | "down";
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PatientPopup = ({
  onClose,
  ...props
}: PatientPopupContainerProps) => {
  const [isOpen, setIsOpen] = useState(props.open);

  useEffect(() => {
    setIsOpen(props.open);
  }, [setIsOpen, props.open]);

  const handleCloseClicked = useCallback(() => {
    setIsOpen(false);
    onClose?.();
  }, [onClose, setIsOpen]);

  return (
    <Slide
      in={isOpen}
      direction={props.slideDirection || "down"}
      mountOnEnter
      unmountOnExit
    >
      <PatientPopupBackground
        className={clsx(props.className, "patient-popup-background")}
      >
        <PatientPopupContainer className={"patient-popup-container"}>
          <CloseButton
            className={"close-button"}
            onClick={handleCloseClicked}
          />
          {props.children}
        </PatientPopupContainer>
      </PatientPopupBackground>
    </Slide>
  );
};
